import Vue from 'vue'
import App from './App.vue'
import { createStore } from './store'

const store = createStore()

new Vue({
  el: '#dps-widget',
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js